import React from "react";
import { Link } from "react-router-dom";
import { recipes, type RecipeId } from "../db/recipes";
import type { RecipeType } from "../types";

type RecipeCardsProps = {
  recipeList: RecipeId[];
  type: RecipeType;
};

function RecipeCards({ recipeList, type }: RecipeCardsProps) {
  const filteredRecipes = recipeList.filter((r) => recipes[r].type === type);

  return (
    <ol className="recipe-cards">
      {filteredRecipes.map((name, index) => (
        <li key={index} className="menu-link" style={{ backgroundImage: `url(${recipes[name].background})` }}>
          <Link to={name}>
            <p>
              <span className="title">{recipes[name].title.toUpperCase()}</span>
              <span className="subtitle">{recipes[name].subtitle.toUpperCase()}</span>
            </p>
          </Link>
        </li>
      ))}
    </ol>
  );
}

export default RecipeCards;
